module.exports = __webpack_public_path__ + "static/media/LearSmith-Logo@2x.2be112c8.png";